import React, { useState } from "react";
import {
  UNLIMITED_PRICE_IDS,
  handleCheckoutClick,
  shouldBlockFreePlanAccess,
} from "../utils/Utils";

export default function FreePlanEndedBanner({ account }) {
  const [checkoutLoading, setCheckoutLoading] = useState(false);
  const [checkoutError, setCheckoutError] = useState(null);

  if (!shouldBlockFreePlanAccess(account)) return null;

  const startUnlimitedCheckout = async () => {
    if (checkoutLoading) return;
    setCheckoutError(null);
    setCheckoutLoading(true);
    try {
      const stripeId =
        account && account.subscription && account.subscription.customer_id
          ? account.subscription.customer_id
          : null;
      const subscriptionStatus =
        account && account.subscription_status
          ? account.subscription_status.type
          : null;
      await handleCheckoutClick(
        stripeId,
        UNLIMITED_PRICE_IDS[0],
        subscriptionStatus,
        account && (account.id || account.account_id),
        account && account.account_email,
        true
      );
    } catch (error) {
      setCheckoutLoading(false);
      setCheckoutError(
        (error && error.message) || "Unable to start checkout"
      );
    }
  };

  return (
    <div className="bg-gray-900 px-4 py-3 sm:px-6">
      <div className="mx-auto flex max-w-[1300px] flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm leading-6 text-white">
          <strong className="font-semibold">The free plan has ended.</strong>{" "}
          Subscribe to Unlimited to keep using Escape Room Studio. Game Master
          access is paused until you subscribe.
        </p>
        <div className="flex flex-shrink-0 items-center gap-3">
          {checkoutError && (
            <span className="text-sm text-red-300">{checkoutError}</span>
          )}
          <button
            type="button"
            onClick={startUnlimitedCheckout}
            disabled={checkoutLoading}
            className="rounded-full bg-white px-3.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm hover:bg-gray-100 disabled:opacity-60"
          >
            {checkoutLoading ? "Redirecting…" : "Subscribe to Unlimited"}
          </button>
        </div>
      </div>
    </div>
  );
}
